<span class="number">{{ number }}</span>
<span class="freud-icon freud-icon-sm freud-icon-check check"></span>
